import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import CryptoJS from 'crypto-js';

const LeadDetail = () => {
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        // Get the lead_id from the query parameter
        const params = new URLSearchParams(location.search);
        const leadId = params.get('lead_id');
        const module = params.get('module');
        const email = params.get('Email');
        if (leadId) {
            // Encrypt the lead ID
            const encryptedId = CryptoJS.AES.encrypt(leadId, 'dbbworldwidepvtltd').toString();
            const encryptedEmailId = CryptoJS.AES.encrypt(email, 'dbbworldwidepvtltd').toString();
            
            if (module === 'ops') {
                navigate(`/ViewOrderDetails?Relocation_ID=${encodeURIComponent(encryptedId)}`);
            }
            else if (module === 'sales') {
                navigate(`/viewleaddetail?Relocation_ID=${encodeURIComponent(encryptedId)}`);
            }
            else if (module === 'converted') {
                window.location.replace(`https://mybooking.carrymypet.com/ClientDocuments?ID=${encodeURIComponent(encryptedId)}&Email=${encodeURIComponent(encryptedEmailId)}`);
            }
        }
    }, [location, navigate]);

    return <div>Redirecting...</div>;
};

export default LeadDetail;